var OZG_IMPLEMENATION_EXPLANATIONS = {
  null: "Keine Informationen vorhanden 🤔",
  "0": "Reifegrad 0 - nichts online 📝",
  "1": "Reifegrad 1 - es gibt Informationen ℹ️",
  "2": "Reifegrad 2 - man kann Anträge ausdrucken 🖨️",
  "3": "Reifegrad 3 - man kann Anträge online versenden 🌏",
  "4": "Reifegrad 4 - Antrag ist online & einfach 🥳"
};

var OZG_MILESTONE_STATES = {
  planning: "Planungsphase",
  design: "Konzeptionsphase",
  implementation: "Umsetzungsphase",
  done: "Fertigstellung"
};

export default { OZG_IMPLEMENATION_EXPLANATIONS, OZG_MILESTONE_STATES };
